<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-18 19:42:34
 * @LastEditors: hayuu
 * @LastEditTime: 2024-11-28 10:31:44
-->
<template>
    <div class="area_mask">
        <div class="area_dia">
            <div class="area_dia_header">
                <h3>区域选择</h3>
            </div>
            <div class="area_dia_body">
                <div class="item">
                    <div class="label">
                        区域选择
                    </div>
                    <el-cascader :props="props" multiple v-model="value" @change="handleChange"
                        popper-class="cascader"></el-cascader>
                </div>
                <div class="btn" @click="handleSubmit">
                    确定
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { removeToken } from '@/utils/auth';

export default {
    data() {
        return {
            value: [],//这里是后端返回的，需要回显的节点的路径
            props: {
                value: 'id',
                label: 'name',
                checkStrictly: true,
                lazy: true,
                lazyLoad: this.lazyLoad,
            }
        }
    },
    created() {
    },
    methods: {
        lazyLoad(node, resolve) {
            let { value, level } = node;
            console.log("node", node);
            let url = "/matter/areaCode/list"
            switch (level) {
                case 0:
                    this.$api.manage.getAction(url, { id: 0 }).then(res => {
                        console.log("【获取区域列表】", res)
                        if (res.code == 200) {
                            const nodes = res.data
                                .map(item => ({
                                    ...item,
                                    leaf: false
                                }));
                            resolve(nodes)
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                    break;
                case 1:
                    this.$api.manage.getAction(url, { id: node.value }).then(res => {
                        console.log("【获取区域列表】", res)
                        if (res.code == 200) {
                            const nodes = res.data
                                .map(item => ({
                                    ...item,
                                    // leaf: false
                                    leaf: true
                                }));
                            resolve(nodes)
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                    break;
                case 2:
                    resolve()
                    // this.$api.manage.getAction(url, { id: node.value }).then(res => {
                    //     console.log("【获取区域列表】", res)
                    //     if (res.code == 200) {
                    //         const nodes = res.data
                    //             .map(item => ({
                    //                 ...item,
                    //                 leaf: true
                    //             }));
                    //         resolve(nodes)
                    //     } else {
                    //         this.$message.error(res.msg)
                    //     }
                    // })
                    break;
                // case 3:
                //     resolve()
                //     break
            }
        },
        handleSubmit() {
            if (this.value.length == 0) return
            removeToken('Admin-Token')
            let that = this
            let url = "/matter/areaCode/info"
            let data = {
                id: this.value[this.value.length - 1]
            }
            this.$api.manage.getAction(url, data).then(res => {
                if (res.code == 200) {
                    this.$emit('submit', JSON.stringify(res.data), res.data.name)
                    if (res.data.type == 3) {
                        that.$api.manage.getAction(url, { id: res.data.pid }).then((r) => {
                            if (r.code == 200) {
                                localStorage.setItem('areaParent', JSON.stringify(r.data))
                            } else {
                                that.$message.error(r.msg)
                            }
                        })
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        handleChange(e) {
            console.log("e", e)

            this.$nextTick(() => {
                const dom = document.getElementsByClassName("el-radio is-checked");
                //这里我把dom打出来看了 最后一个选项才是我选中的节点 即[length-1] 有的博主写的是 第一个元素 即[0] 大家自行尝试
                let radioDom = dom[dom.length - 1];
                const brother = radioDom.nextElementSibling;
                brother.click();


                // return

                const dom2 = document.getElementsByClassName("el-input__inner");
                //这里我把dom打出来看了 最后一个选项才是我选中的节点 即[length-1] 有的博主写的是 第一个元素 即[0] 大家自行尝试
                let radioDom2 = dom2[dom2.length - 1];
                const brother2 = radioDom2.nextElementSibling;
                brother2.click();
                document.getElementsByClassName("cascader")[0].style.display = "none";
            });
        }
    }
}
</script>

<style lang="less" scoped>
.area_mask {
    z-index: 2000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding-top: 210px;
    background: rgba(0, 0, 0, 0.5);

    .area_dia {
        width: 858px;
        height: 340px;
        margin: 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px 0px rgba(212, 212, 212, 0.25);
        border-radius: 16px 16px 16px 16px;

        &_header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 93px;
            padding: 8px 30px 25px;
            background-image: url(@/assets/images/Group_1321314600.png);
            background-size: 100% 100%;

            h3 {
                font-weight: 600;
                font-size: 28px;
                color: #FFFFFF;
                line-height: 33px;
                text-align: left;
            }

            img {
                width: 23px;
                height: 23px;
            }
        }

        &_body {
            width: 100%;
            height: 266px;
            margin-top: -19px;
            padding: 60px 92px 0;
            background: #FFFFFF;
            box-shadow: 0px 4px 4px 0px rgba(212, 212, 212, 0.25);
            border-radius: 16px;
            text-align: left;

            .item {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-bottom: 9px;

                .label {
                    font-weight: 500;
                    font-size: 22px;
                    color: #111111;
                    line-height: 31px;

                    span {
                        font-weight: 500;
                        font-size: 22px;
                        color: #888888;
                        line-height: 31px;
                    }
                }


                .content {
                    width: 100%;

                    textarea {
                        resize: none;
                        width: 100%;
                        height: 180px;
                        padding: 14px 20px;
                        background: #FFFFFF;
                        border-radius: 10px 10px 10px 10px;
                        border: 1px solid #E2E2E2;
                        font-family: PingFangSC;
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 28px;

                        &::placeholder {
                            color: #C6C6C6;
                        }
                    }
                }
            }
        }

        .btn {
            width: 300px;
            height: 66px;
            margin: 0 auto;
            margin-top: 30px;
            background: #3F87FF;
            box-shadow: 0px 6px 0px 0px #1964E0;
            border-radius: 16px 16px 16px 16px;
            font-weight: 600;
            font-size: 26px;
            color: #FFFFFF;
            line-height: 66px;
            text-align: center;
        }
    }
}

::v-deep .el-cascader {
    margin-left: 20px;
    width: 300px;

    .el-input__inner {
        font-size: 20px;
        font-family: PingFangSC;
    }
}
</style>

<style lang="less">
.cascader {
    .el-scrollbar {
        width: 300px;
    }

    .el-cascader-menu__empty-text {
        font-size: 20px;
        font-family: PingFangSC;
    }

    .el-cascader-node {
        height: 40px;
        font-size: 20px;
        font-family: PingFangSC;
        line-height: 40px;
    }
}
</style>